import * as React from "react";
import * as _ from "underscore";
import * as moment from "moment";
import { connect } from "react-redux";
import { InlineNotification } from "carbon-components-react";

import { AppShape, Identifier, InvestorDetail } from "@eave/shared/types/api";
import APIClient from "web_modules/APIClient";
import { mapDispatchToProps } from "../selectors";
import { ZipCodePrefixes } from "./ZipCodePrefixes";

const FontAwesome = require("react-fontawesome");
const styles = require("./styles.module.scss");

interface LoanDetailsProps {
  app: AppShape;
  loadApp: Function;
}

interface State {
  identifier: Identifier;
  selected_investor: any;
  channel_map: any;
  operator: any;
}

class LoanDetails extends React.Component<LoanDetailsProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      identifier: null,
      selected_investor: null,
      channel_map: null,
      operator: null,
    };
  }

  componentDidMount() {
    this.fetchLoanNumberDetails();
  }

  fetchLoanNumberDetails = () => {
    const {
      app: { id },
    } = this.props;

    APIClient.get(`/uw/loan_applications/${id}/investor_detail`).then(resp => {
      const { investor_detail: investorDetail } = resp as { investor_detail: InvestorDetail };
      this.setState({
        selected_investor: investorDetail.investor_name,
      });
    });
  };

  lookupChannelID = () => {
    const { identifier, channel_map } = this.state;
    return channel_map && channel_map[identifier.channel_id];
  };

  lookupGeoName = () => {
    const {
      app: { purchased_property_postal_code },
    } = this.props;

    const { identifier } = this.state;
    if (!identifier || !identifier.geo_id) {
      return undefined;
    }

    const zipCodePrefix = ZipCodePrefixes[purchased_property_postal_code.substring(0, 3)];

    return (zipCodePrefix && zipCodePrefix.CitiesTowns) || "NOT FOUND";
  };

  renderFinalized = () => {
    const { identifier, operator } = this.state;

    if (identifier && identifier.finalized_at) {
      const finalizedAt = moment(identifier.finalized_at);
      return (
        <div>
          <FontAwesome name="check" />
          Generated by {operator.first_name} {operator.last_name} ({operator.email}) on{" "}
          {finalizedAt.format("M/D/YYYY")} at {finalizedAt.format("h:mm a")}
          <InlineNotification
            hideCloseButton
            lowContrast
            kind="success"
            notificationType="inline"
            role="alert"
            title={`Generated by ${operator.first_name} ${operator.last_name} (${
              operator.email
            }) on{" "}
            ${finalizedAt.format("M/D/YYYY")} at ${finalizedAt.format("h:mm a")}`}
          />
        </div>
      );
    }

    return (
      <div>
        <InlineNotification
          hideCloseButton
          lowContrast
          kind="warning"
          notificationType="inline"
          role="alert"
          title="Loan Number will be automatically generated by TRUS at RESPA"
        />
      </div>
    );
  };

  renderLoanNumberExplanation = () => {
    const { identifier, selected_investor } = this.state;
    const { app } = this.props;
    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <td>Loan Number:</td>
            <td colSpan={2}>{app.external_id}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Investor:</td>
            <td>{selected_investor || "__________"}</td>
            <td />
            <td />
            <td />
          </tr>
          <tr>
            <td>Geo:</td>
            <td>
              __
              {(identifier && identifier.geo_id) || "__"}
              ______
            </td>
            <td dangerouslySetInnerHTML={{ __html: this.lookupGeoName() }} />
          </tr>
          <tr>
            <td>Channel:</td>
            <td>
              ____
              {identifier && identifier.channel_id !== null ? identifier.channel_id : "_"}
              _____
            </td>
            <td>{this.lookupChannelID()}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    return (
      <div>
        {this.renderFinalized()}
        {this.renderLoanNumberExplanation()}
      </div>
    );
  }
}

export default connect<any, any, any>(null, mapDispatchToProps)(LoanDetails);
